// extracted by mini-css-extract-plugin
module.exports = {"menu":"UserActions_menu__2QnbM","settings":"UserActions_settings__31lDH"};